/*
* Pipeline Theme custom JS
*/

(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-add-to-cart]');

    if (!button) {
      return;
    }

    setTimeout(function () {
      showAddedCartChoice();
    }, 1200);
  });

  function showAddedCartChoice() {
    var popup = document.getElementById('added-cart-choice-popup');

    if (!popup) {
      popup = document.createElement('div');
      popup.id = 'added-cart-choice-popup';
      popup.className = 'added-cart-choice-popup';

      popup.innerHTML = `
  <div class="added-cart-choice-box">
    <button type="button" class="added-cart-choice-close">×</button>

    <h3>Added to your cart</h3>

    <a href="/collections/all" class="added-cart-choice-button secondary">
      Continue Shopping
    </a>
  </div>
`;

      document.body.appendChild(popup);

      popup.querySelector('.added-cart-choice-close').addEventListener('click', function () {
        popup.style.display = 'none';
      });
    }

    popup.style.display = 'flex';
  }
})();